function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import OrderItem from 'swag-client-common/components/partials/cart/cart-item';
import { DesignUploadMode } from 'swag-common/interfaces';
import { checkIsMoreThanOneItemWithSimilarKey } from 'swag-common/utils/items/is-more-than-one-item-with-similar-key.util';
import { hasSplitShippedItems } from 'swag-common/business-logic/items/get-split-shipped-items';
import { checkIsSplitShippedToInventory } from 'swag-common/utils/order/is-item-split-shipped';
import { getItemWithNonZeroQuantities } from '../../../../../../utils/get-item-with-non-zero-quantities';
import { getImageOfItem, isItemSizeEditable } from '../../../../../../redux/cart/cart.utils';
import BoxOrderItemList from '../box-order-item-list';
import ItemsBlockWrapper from '../items-block-wrapper';
import { setWithBorderFlag } from '../order-item-list/order-item-list-other.utils';
import RegularItemsSummary from '../regular-items-summary';
import RelatedOrderItemList from '../related-order-item-list';
import { InventoryHeader } from './components/inventory-header';
import { getProps } from './get-wrapper-props/get-props';
import classes from './inventory-order-item-list.scss';
class InventoryOrderItemList extends React.Component {
  render() {
    const {
      items,
      selectedItem,
      inventory,
      isLoading,
      isSavedForLater,
      onMoveToCart,
      onMoveToDraft,
      onRemoveItem,
      onEditRequest,
      onEditSizeOfSample,
      onClickMockup,
      onShareClick,
      onProductionTimeClick,
      onProductionTimeChange,
      onSizeClick,
      onQuantityClick
    } = this.props;
    const [firstItem] = items;
    const inventoryName = inventory ? inventory.name : 'Inventory';
    return /*#__PURE__*/React.createElement("div", {
      "data-inventory-container": inventory ? inventory._id : 'Inventory',
      key: firstItem._id,
      className: classes.container
    }, items.map((item, index) => {
      var _itemToUse$3;
      const itemToUse = Array.isArray(item) ? item : [item];
      const hasSplitShipped = hasSplitShippedItems(itemToUse);
      const isBox = Array.isArray(item) && checkIsMoreThanOneItemWithSimilarKey(item, 'boxItemsId');
      const isRelated = Array.isArray(item) && checkIsMoreThanOneItemWithSimilarKey(item, 'asRelatedItemId') && !hasSplitShipped;
      if (isBox) {
        var _itemToUse$;
        return /*#__PURE__*/React.createElement(ItemsBlockWrapper, _extends({
          key: (_itemToUse$ = itemToUse[0]) === null || _itemToUse$ === void 0 ? void 0 : _itemToUse$._id
        }, getProps(items.length, index), {
          isPlainCard: false
        }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InventoryHeader, {
          className: classes.header,
          inventoryName: inventoryName
        }), /*#__PURE__*/React.createElement(BoxOrderItemList, {
          isCart: !isSavedForLater,
          items: itemToUse,
          item: itemToUse[0],
          isLoading: isLoading,
          selectedItem: selectedItem,
          onSizeClick: onSizeClick,
          onRemoveItem: onRemoveItem,
          onShareClick: onShareClick,
          onMoveToCart: onMoveToCart,
          onMoveToDraft: onMoveToDraft,
          onClickMockup: onClickMockup,
          onEditRequest: onEditRequest,
          onQuantityClick: onQuantityClick,
          onEditSizeOfSample: onEditSizeOfSample,
          onProductionTimeClick: onProductionTimeClick,
          onProductionTimeChange: onProductionTimeChange,
          onSampleClick: () => ({}),
          isSpacingAdded: true,
          isPlainCard: false
        })));
      }
      if (isRelated) {
        var _itemToUse$2;
        return /*#__PURE__*/React.createElement(ItemsBlockWrapper, _extends({
          key: (_itemToUse$2 = itemToUse[0]) === null || _itemToUse$2 === void 0 ? void 0 : _itemToUse$2._id
        }, getProps(items.length, index), {
          isPlainCard: false
        }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InventoryHeader, {
          className: classes.header,
          inventoryName: inventoryName
        }), /*#__PURE__*/React.createElement(RelatedOrderItemList, {
          isCart: !isSavedForLater,
          items: itemToUse,
          key: itemToUse[0]._id,
          isLoading: isLoading,
          selectedItem: selectedItem,
          onSizeClick: onSizeClick,
          onRemoveItem: onRemoveItem,
          onShareClick: onShareClick,
          onMoveToCart: onMoveToCart,
          onMoveToDraft: onMoveToDraft,
          onClickMockup: onClickMockup,
          onEditRequest: onEditRequest,
          onQuantityClick: onQuantityClick,
          onEditSizeOfSample: onEditSizeOfSample,
          onProductionTimeClick: onProductionTimeClick,
          onProductionTimeChange: onProductionTimeChange
        })));
      }
      return /*#__PURE__*/React.createElement(ItemsBlockWrapper, _extends({
        key: (_itemToUse$3 = itemToUse[0]) === null || _itemToUse$3 === void 0 ? void 0 : _itemToUse$3._id
      }, getProps(items.length, index)), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InventoryHeader, {
        className: classes.header,
        inventoryName: inventoryName
      }), itemToUse.map((subItem, subItemIndex) => {
        const subItemToUse = checkIsSplitShippedToInventory(subItem) ? getItemWithNonZeroQuantities(subItem) : subItem;
        return /*#__PURE__*/React.createElement(ItemsBlockWrapper, {
          key: subItem === null || subItem === void 0 ? void 0 : subItem._id,
          withBorder: setWithBorderFlag(itemToUse.length, subItemIndex),
          isLastItem: itemToUse.length - 1 === subItemIndex
        }, /*#__PURE__*/React.createElement(OrderItem, {
          key: subItem._id,
          index: index,
          item: subItemToUse,
          isLoading: isLoading,
          isSavedForLater: isSavedForLater,
          selectedItem: selectedItem,
          itemLogoSrc: getImageOfItem(subItem),
          isSizeEditable: isItemSizeEditable(subItem),
          isFullDesign: subItem.prod.designUploadMode === DesignUploadMode.fullDesign,
          isBoxProduct: subItem.prod.designUploadMode === DesignUploadMode.box,
          removeItem: onRemoveItem,
          onSizeClick: onSizeClick,
          moveToCart: onMoveToCart,
          moveToDraft: onMoveToDraft,
          onShareClick: onShareClick,
          onClickMockup: onClickMockup,
          onEditRequest: onEditRequest,
          onQuantityClick: onQuantityClick,
          onEditSizeOfSample: onEditSizeOfSample,
          onProductionTimeClick: onProductionTimeClick,
          onProductionTimeChange: onProductionTimeChange
        }));
      }), /*#__PURE__*/React.createElement(RegularItemsSummary, {
        items: itemToUse
      })));
    }));
  }
}
export { InventoryOrderItemList };